(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (function initReels() {
    const videos = document.querySelectorAll(".reels__video[data-autoplay='true']");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play();
        }
      });
    }, {});

    videos.forEach((video) => observer.observe(video));

    const reels = document.querySelectorAll('.reels__container');

    reels.forEach((reel) => {
      const container = reel.querySelector('.reels');
      const nextBtn = reel.querySelector('button[is="next-button"]');
      const prevBtn = reel.querySelector('button[is="prev-button"]');

      if (!container || !nextBtn || !prevBtn) return;

      function getScrollAmount() {
        const item = container.querySelector('.multi-column__item');
        return item ? item.offsetWidth + parseInt(getComputedStyle(container).columnGap || 0) : 300;
      }

      nextBtn.addEventListener('click', () => {
        container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      prevBtn.addEventListener('click', () => {
        container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') container.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        if (e.key === 'ArrowLeft') container.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
